module.exports = __webpack_public_path__ + "static/case-threads-d63492755c0eb55e7a4cab5356095c00.png";